import React, {useEffect, useState} from 'react';
import Footer from "../common/Footer";
import './Amounts.css';
import Frame from "../common/Frame";
import {useTranslation} from "react-i18next";
import {appdata, save} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {logPageOpened} from "../model/utils";
import {HallPlan} from "../common/HallPlan";


export function Amounts() {
    const {t} = useTranslation()
    const [error, setError] = useState("");
    const [cntFull, setCntFull] = useState(0);
    const [cntReduced, setCntReduced] = useState(0);
    const history = useHistory();

    useEffect(() => {
        logPageOpened(window.location.pathname, "Pay")
        setState()
    }, [])


    function setState() {
        calculate()
        setCntFull(appdata.countFull)
        setCntReduced(appdata.countReduced)
        setError("")
    }

    function handleSubmit(event) {
        event.preventDefault();
        registerConcersion('AddToCart');
        if (validate()) {
            save();
            history.push("/lead");
        }
    }

    function handleChange(event) {

        let input1 = event.target.value
        if (input1 === NaN || input1 === "" || input1 === undefined)
            input1 = 0
        input1 = parseInt(input1)


        if ("fullCnt" === event.target.id) {
            appdata.countFull = input1
        } else {
            appdata.countReduced = input1
        }
        setState()
    }

    function changeCount(field, change) {
        if ("Full" === field) {
            appdata.countFull = appdata.countFull + change;
            if (appdata.countFull < 0)
                appdata.countFull = 0;
        } else {
            appdata.countReduced = appdata.countReduced + change;
            if (appdata.countReduced < 0)
                appdata.countReduced = 0;

        }
        setState()
    }

    function calculate() {
        appdata.count = appdata.countFull + appdata.countReduced;
        appdata.amount = appdata.countFull * appdata.priceFull;
        if (appdata.countReduced !== 0)
            appdata.amount = Math.round((appdata.amount + appdata.countReduced * appdata.priceReduced) * 100) / 100;

    }

    let fullTicketHeader = "Ticket"
    if (appdata.priceReduced > 0) {
        fullTicketHeader = "fullTicketDescription"
    }
    appdata.header = undefined

    function validate() {
        // @ts-ignore
        setState()
        if (appdata.count === 0) {
            setError(t("PleaseSelectOneTicket"))
            return false;
        }
        if (appdata.count > 6 && appdata.priceFull < 5) {
            setError(t("PleaseNotMoreThan6TicketsOnce"))
            return false;
        }
        return true;
    }
    let sectorInfo
    let sectorInfo2

    if (appdata.product["sector"] !== undefined){
        sectorInfo = t(appdata.product["sector"]["descriptionKey"])
        sectorInfo2 = t("rows") + " " + appdata.product["sector"]["startRow"] + "-" +  appdata.product["sector"]["endRow"]
    }
    let placementKey = "FreePlacement"
    if (appdata.product["seatsType"] === "FIXED")
        placementKey = "HowToSelectSeats"
    if (appdata.product["seatsType"] === "ZONES")
        placementKey = "HowToSelectZones"
    if (appdata.product["seatsType"] === "ONLINE")
        placementKey = "HowToConnecToOnline"
    if (appdata.product["homepageUrl"] === "https://duoclassico.eu/michael2025-listz-1-en")
        placementKey = "CARNEGIEHALLPlacementKey"

    return (
        <div id="amountPage">
            <Frame>
                <div>
                    <div className="calculate">
                        <form className="offer__form" method="post" id="lead_form" onSubmit={handleSubmit}>
                            <h2 className="app-title">
                                <p>{t('PleaseSelectNumberOfTickets')}</p>
                            </h2>
                            {(appdata.product["seatsType"] === "FIXED")?
                            <div>
                                <p className="app-text">
                                    {sectorInfo} {sectorInfo2}
                                </p>
                                <br/><br/>
                            </div>:<div></div>
                            }
                            <div className="offer__label-wrap">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>{t(fullTicketHeader)}:{appdata.priceFull}{appdata.product["currency"]}</td>
                                        <td>
                                            <div className="offer__value fullPrice">
                                                <div className="offer__change">
                                                <span className="offer__minus" id="fullCntDown"
                                                      onClick={() => changeCount("Full", -1)}>-</span>
                                                    <input type="number" id="fullCnt" min="0" value={cntFull}
                                                           onChange={handleChange}/>
                                                    <span className="offer__plus" id="fullCntUp"
                                                          onClick={() => changeCount("Full", 1)}>+</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><br/><br/></td>
                                    </tr>
                                    {appdata.priceReduced > 0 ?
                                        <tr>
                                            <td>{t("reducedTicketDescription")}:{appdata.priceReduced}{appdata.product["currency"]}</td>
                                            <td>
                                                <div className="offer__value fullPrice">
                                                    <div className="offer__change">
                                                    <span className="offer__minus" id="reducedCntDown"
                                                          onClick={() => changeCount("Reduced", -1)}>-</span>
                                                        <input type="number" id="reducedCnt" min="0"
                                                               value={cntReduced} onChange={handleChange}/>
                                                        <span className="offer__plus" id="reducedCntUp"
                                                              onClick={() => changeCount("Reduced", 1)}>+</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr> : <tr></tr>}
                                    </tbody>
                                </table>
                            </div>
                            <br></br>
                            <ul className="offer__total">
                                <li className="offer__total-item offer__total-item_sum">{t("Amount")}:{appdata.amount}{appdata.product["currency"]}
                                </li>
                            </ul>
                            <p className="app-text">
                                {error}
                            </p>
                            <div className="app-button d-flex justify-content-around">
                                <button id="nextButtonAmt" type="submit"
                                        className="app-btn app-btn-further next-step-btn">
                                    <span>{t("NextButton")}</span>
                                </button>
                            </div>
                            <p className="app-text">
                                {t(placementKey)}
                            </p>
                        </form>
                    </div>
                </div>
            </Frame>
        </div>
    )
}


